(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("angular"), require("api-check"), require("angular-formly"));
	else if(typeof define === 'function' && define.amd)
		define(["angular", "api-check", "angular-formly"], factory);
	else if(typeof exports === 'object')
		exports["ngFormlyTemplatesBootstrap"] = factory(require("angular"), require("api-check"), require("angular-formly"));
	else
		root["ngFormlyTemplatesBootstrap"] = factory(root["angular"], root["apiCheck"], root["ngFormly"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_20__, __WEBPACK_EXTERNAL_MODULE_21__, __WEBPACK_EXTERNAL_MODULE_22__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/